// extracted by mini-css-extract-plugin
module.exports = {"main":"admin_main__17uu4","mainFullWidth":"admin_mainFullWidth__3nUDo","appContent":"admin_appContent__L7ZfC"};